// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"84a9f5ef","703":"85bc13be","787":"f457c4a6"}[chunkId] + ".chunk.js";
};